// Each module in this file should be considered independent of
// templates or individual routes. Instead, each module should be
// dynamically imported based on a test criteria such as the
// presence of a DOM element with a given data attribute.

// This file is loaded globally but should just contain dynamically
// loaded module logic only.

// --------------------------------
// Import and execute the global JS
// --------------------------------

if (true) {
    import('./main')
    .then(({ mainJs }) => {
        mainJs()
    })
}

// --------------------------------
// Fade in and up animation when in viewport
// --------------------------------
const fadeInUpElements = document.querySelectorAll('[data-animation="fadeInUp"]')

if (fadeInUpElements.length > 0) {
    import('./animation/fade-in-up')
    .then(({ fadeInUp }) => {
            fadeInUpElements.forEach(element => {
                fadeInUp(element)
            })
        })
}

// --------------------------------
// Animate cards on scroll within a grid
// --------------------------------
// const grids = document.querySelectorAll('[data-animation="grid-cards"]')
//
// if (grids.length > 0) {
//   import('./animation/grid-cards')
//     .then(({ gridCards }) => {
//          grids.forEach(grid => {
//              gridCards(grid)
//          })
//      })
// }

// --------------------------------
// Team
// --------------------------------
const teamContainers = document.querySelectorAll('[data-module="team"]')

if (teamContainers.length > 0) {
    import('./components/team')
            .then(({ team }) => {
                teamContainers.forEach(container => {
                    team(container)
                })
            })
}

// --------------------------------
// Scroll to a target (with smooth scroll)
// --------------------------------
// const scrollToTriggers = document.querySelectorAll('[data-module="scroll-to"]')
//
// if (scrollToTriggers.length > 0) {
//   import('./components/scroll-to')
//     .then(({ scrollTo }) => {
//          scrollToTriggers.forEach(trigger => {
//              scrollTo(trigger)
//          })
//      })
// }

// --------------------------------
// Video
// --------------------------------
const videos = document.querySelectorAll('[data-module="video"]')

if (videos.length > 0) {
    import('./components/video-observer')
            .then(({ videoObserver }) => {
                videos.forEach(element => {
                    videoObserver(element)
                })
            })
}

// --------------------------------
// Auto play videos when they are in the viewport
// --------------------------------
const autoPLayVideos = document.querySelectorAll('[data-module="autoplay-video"]')

if (autoPLayVideos.length > 0) {
    import('./components/video-autoplay')
            .then(({ videoAutoplay }) => {
                autoPLayVideos.forEach(video => {
                    videoAutoplay(video)
                })
            })
}


// --------------------------------
// Home video and menu
// --------------------------------
const homeElements = document.querySelectorAll('[data-module="home"]')

if (homeElements.length > 0) {
    import('./components/home')
            .then(({ home }) => {
                homeElements.forEach(homeEl => {
                    home(homeEl)
                })
            })
}

// --------------------------------
// About banner
// --------------------------------
const aboutBannerElements = document.querySelectorAll('[data-module="about-banner"]')

if (aboutBannerElements.length > 0) {
    import('./components/about-banner')
        .then(({ aboutBanner }) => {
            aboutBannerElements.forEach(bannerEl => {
                aboutBanner(bannerEl)
            })
        })
}

// --------------------------------
// Single productions intro
// --------------------------------
const singleProductionsIntroElements = document.querySelectorAll('[data-module="single-intro"]')

if (singleProductionsIntroElements.length > 0) {
    import('./components/production-intro')
        .then(({ singleProductionsIntro }) => {
            singleProductionsIntroElements.forEach(introEl => {
                singleProductionsIntro(introEl)
            })
        })
}

// --------------------------------
// Tabs
// --------------------------------
const tabsElements = document.querySelectorAll('[data-module="tabs"]')

if (tabsElements.length > 0) {
    import('./components/tabs')
        .then(({ tabs }) => {
            tabsElements.forEach(tabsEl => {
                tabs(tabsEl)
            })
        })
}

// --------------------------------
// Tabs
// --------------------------------
const imageSliderElements = document.querySelectorAll('[data-module="image-slider"]')

if (imageSliderElements.length > 0) {
    import('./components/image-slider')
        .then(({ imageSlider }) => {
            imageSliderElements.forEach(sliderEl => {
                imageSlider(sliderEl)
            })
        })
}

const careersImageSliderElements = document.querySelectorAll('[data-module="careers-image-slider"]')

if (careersImageSliderElements.length > 0) {
    import('./components/careers-image-slider')
        .then(({ careersImageSlider }) => {
            careersImageSliderElements.forEach(sliderEl => {
                careersImageSlider(sliderEl)
            })
        })
}

// --------------------------------
// Grid
// --------------------------------
const gridElements = document.querySelectorAll('[data-module="grid"]')

if (gridElements.length > 0) {
    import('./components/grid')
        .then(({ grid }) => {
            gridElements.forEach(gridEl => {
                grid(gridEl)
            })
        })
}

// --------------------------------
// Careers
// --------------------------------
const careersListElements = document.querySelectorAll('[data-module="careers"]')

if (careersListElements.length > 0) {
    import('./components/careers-list')
        .then(({ careers }) => {
            careersListElements.forEach(careersEl => {
                careers(careersEl)
            })
        })
}